import { createPinia, defineStore } from "pinia";

export const store = createPinia();

export const useAppStore = defineStore("app", {
  state: () => {
    return {
      user: {
        accessToken: "",
        expiresIn: "",
      },

      /** ====== 时间相关 ====== */
      serverTime: 0, // 对外展示的“当前服务器时间”
      serverBaseTime: 0, // 同步时的服务器时间
      clientBaseTime: 0, // 同步瞬间的本地时间
      clockInterval: undefined,

      /** ====== 业务数据 ====== */
      examPaper: undefined,
      examMsg: undefined,
    };
  },

  getters: {
    getAccessToken() {
      return this.user.accessToken;
    },
    getExpiresIn() {
      return this.user.expiresIn;
    },
    getServerTime() {
      return this.serverTime;
    },
    getExamPaper() {
      return this.examPaper;
    },
    getMd5() {
      return localStorage.getItem("MD5");
    },
    getUserInfo() {
      return localStorage.getItem("user_info");
    },
    getClock() {
      return this.clockInterval;
    },
    getExamMsg() {
      return this.examMsg;
    },
  },

  actions: {
    SET_USER(payload) {
      this.user = payload;
    },

    SET_PAPER(val) {
      this.examPaper = val;
    },

    SET_MD5(val) {
      localStorage.setItem("MD5", val);
    },

    SET_USER_INFO(val) {
      localStorage.setItem("user_info", val);
    },

    /**
     * ✅ 设置服务器时间（位移模型）
     * @param {number} serverTimestamp 服务器返回的毫秒时间戳
     */
    SET_CLOCK(serverTimestamp) {
      // 清理旧定时器
      clearInterval(this.clockInterval);

      // 记录基准
      this.serverBaseTime = serverTimestamp;
      this.clientBaseTime = Date.now();

      // 立即算一次，避免 UI 延迟
      this.serverTime = serverTimestamp;

      // 仅用于 UI 刷新，不参与时间计算
      this.clockInterval = setInterval(() => {
        this.serverTime =
          this.serverBaseTime + (Date.now() - this.clientBaseTime);
      }, 1000);
    },

    SET_EXAM_MSG(val) {
      this.examMsg = val;
    },

    CLEAR_CACHE() {
      this.serverTime = 0;
      this.serverBaseTime = 0;
      this.clientBaseTime = 0;

      clearInterval(this.clockInterval);
      this.clockInterval = undefined;

      this.examPaper = undefined;
      this.examMsg = undefined;

      localStorage.clear();
    },
  },
});

export const useAppStoreWithOut = () => {
  return useAppStore(store);
};
